<template>
  <div class="nptice">
    <div class="nav">
      <h1>{{ list.title }}</h1>
    </div>
    <div class="body" v-html="list.content"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import qs from "qs";

export default {
  name: "Dashboard",
  data() {
    return {
      crm: {},
      list: {},
    };
  },
  mounted() {
    // if (window.sessionStorage.getItem("title")) {
    //   let title = JSON.parse(window.sessionStorage.getItem("title"));
    //   this.title = title;
    //   var a = document.title;
    //   document.title = title[0].website + "-" + a;
    // }
    if (window.sessionStorage.getItem("userinfo")) {
      let userinfo = JSON.parse(window.sessionStorage.getItem("userinfo"));
      this.username = userinfo;
    }
    this.abue();
  },
  methods: {
    abue() {
      this.axios
        .post(
          "/api/notice/lookNotice",
          qs.stringify({
            agent_id: this.username.id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.list = res.data.data;
        })
        .catch(function (err) {});
    },
  },
};
</script>

<style scoped>
.nav {
  font-size: 23px;
  text-align: center;
}
.body {
  width: 60%;
  margin: 0 auto;
  margin-top: 5.0rem;
  font-size: 18px;
}
</style>
